// Resources:
// https://www.youtube.com/watch?v=BuJ3yrpSj-g

// import 'phaser';
import bindAllOfThis from "src/utils/BindThisHelper";
import { PhaserButton, PhaserButtonConfig } from 'src/games/shared/Button';
import TranslateApi from 'src/utils/TranslateHelper';
import { Color } from 'src/games/shared/ColorValue';

export class MainScene extends Phaser.Scene {

    private BOARD_DIM: number = 4;
    private GAME_WIDTH: number = 1360;
    private GAME_HEIGHT: number = 768;

    private PIECE_WIDTH: number;
    private PIECE_HEIGHT: number;

    private blockGroup: Phaser.GameObjects.Image[];
    private blackBlock: Phaser.GameObjects.Image;
    private blocksLeftText: Phaser.GameObjects.Text;
    private clickLock: boolean;

    private borderSize: number;
    private count: number;
    private text: Phaser.GameObjects.Text;
    private outline: Phaser.GameObjects.Image;
    private speechBox: Phaser.GameObjects.Image;

    private translateString: string;

    private timer: Phaser.Time.TimerEvent;
    private timeText: Phaser.GameObjects.Text;
    private helpFlag: boolean;
    private startTime: boolean;

    private yesButton: PhaserButton;
    private noButton: PhaserButton;

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
        if (this.BOARD_DIM !== 4) {
            throw new Error("Invalid board dimension");
        }
        this.startTime = false;
        this.helpFlag = false;
        this.borderSize = 5;
        this.PIECE_WIDTH = Math.floor(this.GAME_WIDTH / 8);
        this.PIECE_HEIGHT = this.PIECE_WIDTH;
    }

    preload() {
        let num = Math.ceil(Math.random() * 6);
        if (num === 1) {
            this.load.spritesheet("key", require("/src/assets/qci/sprites/sliderPuzzle/accountant.png"), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", require("/src/assets/qci/sprites/sliderPuzzle/accountant.png"), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", require("/src/assets/qci/sprites/sliderPuzzle/accountant.png"));
        }
        else if (num === 2) {
            this.load.spritesheet("key", require("/src/assets/qci/sprites/sliderPuzzle/assistant.png"), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", require("/src/assets/qci/sprites/sliderPuzzle/assistant.png"), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", require("/src/assets/qci/sprites/sliderPuzzle/assistant.png"));
        }
        else if (num === 3) {
            this.load.spritesheet("key", require("/src/assets/qci/sprites/sliderPuzzle/hospital-orderly.png"), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", require("/src/assets/qci/sprites/sliderPuzzle/hospital-orderly.png"), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", require("/src/assets/qci/sprites/sliderPuzzle/hospital-orderly.png"));
        }
        else if (num === 4) {
            this.load.spritesheet("key", require("/src/assets/qci/sprites/sliderPuzzle/hotel-receptionist.png"), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", require("/src/assets/qci/sprites/sliderPuzzle/hotel-receptionist.png"), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", require("/src/assets/qci/sprites/sliderPuzzle/hotel-receptionist.png"));
        }
        else if (num === 5) {
            this.load.spritesheet("key", require("/src/assets/qci/sprites/sliderPuzzle/librarian.png"), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", require("/src/assets/qci/sprites/sliderPuzzle/librarian.png"), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", require("/src/assets/qci/sprites/sliderPuzzle/librarian.png"));
        }
        else if (num === 6) {
            this.load.spritesheet("key", require("/src/assets/qci/sprites/sliderPuzzle/pharmacy-tech.png"), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
            this.load.spritesheet("key3", require("/src/assets/qci/sprites/sliderPuzzle/pharmacy-tech.png"), { frameWidth: Math.floor(this.GAME_WIDTH / 6), frameHeight: Math.floor(this.GAME_WIDTH / 6) });
            this.load.image("finishedKey", require("/src/assets/qci/sprites/sliderPuzzle/pharmacy-tech.png"));
        }
        this.load.image("white", require("/src/assets/games/coinRunner/white.png"));
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.image('terrain', require("/src/assets/qci/backgrounds/terrains/c.png"));
        this.load.atlas("pilots", require("/src/assets/qci/atlas/starPilotAll.png"), require("/src/assets/qci/atlas/starPilotAll.json"));
    }

    create() {
        this.translateString = "PuzzleSlider.Phaser.";
        let sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.GAME_WIDTH, this.GAME_HEIGHT);
        sky.setTint(0x6eb8e5, 0x6eb8e5, 0xffffff, 0xffffff); // Gradient sky!
        let terrain = this.add.image(0, 400, "terrain");
        terrain.setScale(0.8);
        terrain.setOrigin(0);
        this.timeText = this.add.text(this.GAME_WIDTH - 125, 200, "0:00", { fill: "#000000", align: "center" }).setDepth(10).setOrigin().setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(30);
        this.setupText();
        this.setupTimer();
        this.setupBoard();
        this.count = this.checkNumLeft();
        this.addControlPanel();
        this.addRescrambleButton();
        this.makeBlocksLeftBox();
    }

    setupText(): void {
        this.text = this.add.text(935, 505, "", { fill: "#ffffff", align: "center" }).setFontFamily('Roboto Mono, Russo One, Arial').setFontSize(24);
        this.text.setWordWrapWidth(230);
        this.text.setOrigin(.5);
        this.text.setDepth(3);

        this.speechBox = this.add.image(820, 455, "pixel");
        this.speechBox.setOrigin(0);
        this.speechBox.setTint(0x000000);
        this.speechBox.setDepth(2.75);
        this.speechBox.setDisplaySize(230, 130);
        this.speechBox.setAlpha(0);

        this.outline = this.add.image(815, 450, "pixel");
        this.outline.setOrigin(0);
        this.outline.setTint(0xFFFF00);
        this.outline.setDisplaySize(240, 140);
        this.outline.setDepth(2.5);
        this.outline.setAlpha(0);
    }

    setupTimer(): void {
        this.timer = this.time.addEvent({ delay: 10000000, timeScale: 1.0 });
        var clock = this.add.image(this.GAME_WIDTH - 125, 200, "pixel").setDisplaySize(110, 50).setDepth(6.5);
        var clockBorder = this.add.image(clock.x, clock.y, "pixel").setDisplaySize(120, 60).setDepth(6).setTint(0x000000);
    }

    setupBoard(): void {
        this.clickLock = false;
        let order: number[] = [];
        order = this.createSolvableIndexArray();
        this.createBlocks(order, "key");
    }

    makeBlocksLeftBox(): void {
        let box = this.add.image(this.blocksLeftText.x, this.blocksLeftText.y, "pixel");
        box.setDisplaySize(this.blocksLeftText.displayWidth + 20, this.blocksLeftText.displayHeight + 10);
        box.setDepth(2);
        let edge = this.add.image(box.x, box.y, "pixel");
        edge.setDisplaySize(box.displayWidth + 10, box.displayHeight + 10);
        edge.setTint(0x000000);
        edge.setDepth(1.5);
    }

    createBlocks(orderArray: number[], key: string): void {
        this.blockGroup = [];
        let count = 0;
        var padding = 4 * this.borderSize;

        for (let row = 0; row < this.BOARD_DIM; row++) {
            for (let col = 0; col < this.BOARD_DIM; col++) {
                // Wherever the largest number is in the order array, use that index for the black block
                if (orderArray[count] === this.BOARD_DIM * this.BOARD_DIM - 1) {
                    this.blackBlock = this.add.sprite((col) * (this.PIECE_WIDTH + 2) + padding, (row) * (this.PIECE_HEIGHT + 2) + 2 * padding, "white");
                    this.blackBlock.setOrigin(0);
                    this.blackBlock.setDepth(1);
                    this.blackBlock.setTint(0xd3d3d3);
                    this.blackBlock.setDisplaySize(this.PIECE_WIDTH, this.PIECE_HEIGHT);
                    this.blackBlock.setAlpha(0);
                    this.blackBlock.name = "black";
                    this.blackBlock.setData("key", orderArray[count]);
                    this.blockGroup.push(this.blackBlock);
                    count++;
                }
                // Create normal blocks using the sprite for the rest of the blocks
                else {
                    let block: Phaser.GameObjects.Image = this.add.sprite((col) * (this.PIECE_WIDTH + 2) + padding, (row) * (this.PIECE_HEIGHT + 2) + 2 * padding, key, orderArray[count]);
                    block.setOrigin(0);
                    block.setInteractive();
                    block.setDepth(2);
                    block.setDisplaySize(this.PIECE_WIDTH, this.PIECE_HEIGHT);
                    block.setData("key", orderArray[count]);
                    block.on('pointerdown', () => {
                        this.switchBlocks(block, this.blackBlock);
                    });
                    count++;
                    this.blockGroup.push(block);
                }
            }
        }
    }

    addRescrambleButton(): void {
        var config = new PhaserButtonConfig();
        config.backgroundColor = Color.KUDER_PRIMARY_BUTTON;
        config.smartSize = true;
        var text = TranslateApi.translate(this.translateString + "reshuffle");
        var button = new PhaserButton(this, this.GAME_WIDTH - 200, 50, 150, 50, text, config);
        button.setX(this.GAME_WIDTH - button.width - 69);
        button.setDepth(3);
        button.on('buttonClicked', () => {
            if (!this.clickLock) {
                this.destroyOldPieces();
                if (this.BOARD_DIM === 4) {
                    this.setupBoard();
                }
                else if (this.BOARD_DIM === 3) {
                    this.setup3Board();
                }
                if (this.helpFlag) {
                    this.yesButton.destroy();
                    this.noButton.destroy();
                }
                this.helpFlag = false;
                this.startTime = false;
                this.timeText.setText("0:00");
                this.setupTimer();
                this.text.setText("");
                this.outline.setAlpha(0);
                this.speechBox.setAlpha(0);
                this.blocksLeftText.destroy();
                this.checkNumLeft();
            }
        });
    }

    addControlPanel(): void {
        let pic: Phaser.GameObjects.Image = this.add.image(780, 55, "finishedKey");
        pic.setDepth(3);
        pic.setOrigin(0);
        pic.setAlpha(1);
        pic.setDisplaySize(320, 320);
        let border: Phaser.GameObjects.Image = this.add.image(775, 50, "pixel");
        border.setTint(0x000000);
        border.setOrigin(0);
        border.setDisplaySize(330, 330);
        border.setDepth(2);
        let astronaut: Phaser.GameObjects.Image = this.add.image(1200, 603, "pilots", "c");
        astronaut.setDepth(3);
        astronaut.setOrigin(.5);
        astronaut.setScale(.5, .5);
    }

    switchBlocks(toSwitch: Phaser.GameObjects.Image, black: Phaser.GameObjects.Image): void {
        if (this.clickLock) {
            return;
        }
        let diffX: number = Math.abs(black.x - toSwitch.x);
        let diffY: number = Math.abs(black.y - toSwitch.y);
        if (!this.isBlockMovable(diffX, diffY)) {
            return;
        }
        this.clickLock = true;
        if (!this.startTime) {
            this.setupTimer();
            this.startTime = true;
        }
        // Change the block's locations in the blockgroup array
        let swIndex: number = this.blockGroup.indexOf(toSwitch);
        let blIndex: number = this.blockGroup.indexOf(black);
        this.blockGroup[blIndex] = toSwitch;
        this.blockGroup[swIndex] = black;
        this.moveBlock(toSwitch, this.blackBlock);
    }

    /**
     * moveBlock function adds tween animation to moving blocks
     * @param block
     * @param blackBlock
     */
    moveBlock(block: Phaser.GameObjects.Image, blackBlock: Phaser.GameObjects.Image): void {
        this.tweens.add({
            targets: blackBlock,
            x: block.x,
            y: block.y,
            duration: 400,
            onComplete: () => {
            }
        });
        this.tweens.add({
            targets: block,
            x: blackBlock.x,
            y: blackBlock.y,
            duration: 400,
            onComplete: () => {
                this.clickLock = false;
                this.checkIfCompleted();
            }
        });
    }

    isBlockMovable(diffX: number, diffY: number): boolean {
        if (diffX === (this.PIECE_WIDTH + 2) && diffY === (this.PIECE_HEIGHT + 2)) {
            return false;
        }
        if (diffX > (this.PIECE_WIDTH + 2) || diffY > (this.PIECE_HEIGHT + 2)) {
            return false;
        }
        return true;
    }

    createSolvableIndexArray(): number[] {
        let indexArray = [];
        for (let i = 0; i < this.BOARD_DIM * this.BOARD_DIM; i++) {
            indexArray.push(i);
        }
        let scrambleIndex: number = 0;
        while (scrambleIndex < 10) {
            for (let j = 0; j < 75; j++) {
                let blackIndex = indexArray.indexOf(15);
                let rand = Math.random() * 4;
                if (rand < 1) {
                    if (blackIndex !== 0 && blackIndex !== 4 && blackIndex !== 8 && blackIndex !== 12) {
                        this.swap(indexArray, blackIndex, blackIndex - 1);
                    }
                }
                else if (rand < 2) {
                    if (blackIndex !== 0 && blackIndex !== 1 && blackIndex !== 2 && blackIndex !== 3) {
                        this.swap(indexArray, blackIndex, blackIndex - 4);
                    }
                }
                else if (rand < 3) {
                    if (blackIndex !== 3 && blackIndex !== 7 && blackIndex !== 11 && blackIndex !== 15) {
                        this.swap(indexArray, blackIndex, blackIndex + 1);
                    }
                }
                else if (rand < 4) {
                    if (blackIndex !== 12 && blackIndex !== 13 && blackIndex !== 14 && blackIndex !== 15) {
                        this.swap(indexArray, blackIndex, blackIndex + 4);
                    }
                }
            }
            for (let i = 0; i < indexArray.length; i++) {
                if (indexArray[i] !== i) {
                    scrambleIndex++;
                }
            }
        }
        return indexArray;
    }

    swap(arr: number[], blackIndex: number, toSwap: number): void {
        let temp: number = arr[toSwap];
        arr[toSwap] = arr[blackIndex];
        arr[blackIndex] = temp;
    }

    checkIfCompleted(): void {
        var count = 0;
        let iter = this.blockGroup.values();
        for (let row = 0; row < this.BOARD_DIM; row++) {
            for (let col = 0; col < this.BOARD_DIM; col++) {
                if (iter.next().value.getData("key") !== count) {
                    if (!this.helpFlag) {
                        this.outline.setAlpha(0);
                        this.speechBox.setAlpha(0);
                        this.text.setText("");
                    }
                    this.blocksLeftText.destroy();
                    let num = this.checkNumLeft();
                    if (this.count > num && !this.helpFlag) {
                        let rand = Math.random() * 4;
                        if (rand < 1) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.1"));
                        }
                        else if (rand < 2) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.2"));
                        }
                        else if (rand < 3) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.3"));
                        }
                        else {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.4"));
                        }
                    }
                    this.count = num;
                    return;
                }
                count++;
            }
        }
        this.showFinishedText();
        this.blocksLeftText.destroy();
    }

    checkNumLeft(): number {
        let num: number = 0;
        let iter = this.blockGroup.values();
        for (let i = 0; i < this.blockGroup.length; i++) {
            let next = iter.next().value.getData("key");
            if (next !== i) {
                if ((this.BOARD_DIM === 3 && next === 8) || (this.BOARD_DIM === 4 && next === 15)) {
                    // dont add to num, black block
                }
                else {
                    num++;
                }
            }
        }

        let scoreText = TranslateApi.translate(this.translateString + "score");
        let str: string = scoreText + num;
        this.blocksLeftText = this.add.text(945, 410, str, { fill: "#000000", align: "center" }).setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(24);
        this.blocksLeftText.setDepth(3);
        this.blocksLeftText.setOrigin(.5);

        return num;
    }

    showFinishedText() {
        this.clickLock = true;
        this.startTime = false;
        var style = { font: "40px Arial", fill: "#0C0C0C", align: "center" };
        let finish: Phaser.GameObjects.Image = this.add.image(0, 0, "finishedKey").setDepth(3).setOrigin(0).setAlpha(1).setDisplaySize(726, 726);
        finish.setPosition(this.GAME_WIDTH / 2 - finish.displayWidth / 2, this.GAME_HEIGHT / 2 - finish.displayHeight / 2);
        let text = this.add.text(360, 360, TranslateApi.translate(this.translateString + "finished"), style).setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(30).setOrigin(0).setDepth(5);
        text.setPosition(this.GAME_WIDTH / 2 - text.width / 2, this.GAME_HEIGHT / 2 - text.height / 2);
        this.add.image(text.getCenter().x, text.getCenter().y, "pixel").setDisplaySize(text.displayWidth + 10, text.displayHeight + 10).setDepth(4).setOrigin(.5);
        this.add.image(text.getCenter().x, text.getCenter().y, "pixel").setDisplaySize(text.displayWidth + 20, text.displayHeight + 20).setDepth(3.5).setOrigin(.5).setTint(0x000000);

        var moveOn = TranslateApi.translate("student.postgame.button");
        var buttonConfig = { backgroundColor: 0x6ec213, textColor: 0xffffff, textSize: 30 };
        var buttonText = this.add.text(0, 0, moveOn, style).setVisible(false);
        var button = new PhaserButton(this, text.getCenter().x, text.getCenter().y + 200, buttonText.displayWidth + 10, buttonText.displayHeight + 10, moveOn, buttonConfig);
        button.setDepth(4).setPosition(button.x - button.displayOriginX, button.y - button.displayOriginY);
        button.on("buttonClicked", () => {
            // Game Over
            (this.sys.game as any).onComplete();
        });
    }

    destroyOldPieces(): void {
        let iter = this.blockGroup.values();
        for (let i = 0; i < this.blockGroup.length; i++) {
            iter.next().value.destroy();
        }
    }

    setTime(): void {
        if (this.startTime) {
            var minute: number = Math.floor(this.timer.getElapsedSeconds() / 60);
            var second: number = Math.floor(this.timer.getElapsedSeconds() % 60);

            if (second < 10) {
                this.timeText.setText(minute.toString() + ":0" + second.toString());
            }
            else {
                this.timeText.setText(minute.toString() + ":" + second.toString());
            }
            // Change these conditions to reduce or increase time until reduce difficulty option
            // Allow reduction option every 7 minutes until they say yes or finish
            if ((minute % 7 === 0 && minute !== 0) && second === 0 && !this.helpFlag && !this.clickLock && this.BOARD_DIM !== 3) {
                this.helpFlag = true;
                this.reduceDifficulty();
            }
        }
    }

    reduceDifficulty(): void {
        console.warn("reduce difficulty");
        this.outline.setAlpha(1);
        this.speechBox.setAlpha(1);
        this.text.setText(TranslateApi.translate(this.translateString + "help"));

        let yesConfig = new PhaserButtonConfig();
        yesConfig.backgroundColor = Color.KUDER_PRIMARY_BUTTON;
        var noConfig = new PhaserButtonConfig();
        noConfig.backgroundColor = Color.KUDER_SECONDARY_BUTTON;

        this.yesButton = new PhaserButton(this, 850, 610, 190, 30, TranslateApi.translate(this.translateString + "yes"), yesConfig);
        this.yesButton.setDepth(3);

        this.noButton = new PhaserButton(this, 850, 655, 190, 30, TranslateApi.translate(this.translateString + "no"), noConfig);
        this.noButton.setDepth(3);

        this.yesButton.on('buttonClicked', () => {
            if (!this.clickLock) {
                this.destroyOldPieces();
                this.setup3Board();
                this.checkNumLeft();
                this.timer = this.time.addEvent({ delay: 10000000, timeScale: 1.0 });
                this.timeText.setText("0:00");
                this.startTime = false;
                this.helpFlag = false;
                this.yesButton.destroy();
                this.noButton.destroy();
            }
        });

        this.noButton.on('buttonClicked', () => {
            if (!this.clickLock) {
                this.timer.elapsed = this.timer.elapsed + 1000;
                this.outline.setAlpha(0);
                this.speechBox.setAlpha(0);
                this.text.setText("");
                this.helpFlag = false;
                this.noButton.destroy();
                this.yesButton.destroy();
            }
        });
    }

    setup3Board(): void {
        this.BOARD_DIM = 3;
        this.PIECE_WIDTH = Math.floor(this.GAME_WIDTH / 6);
        this.PIECE_HEIGHT = this.PIECE_WIDTH;
        this.blocksLeftText.destroy();
        this.outline.setAlpha(0);
        this.speechBox.setAlpha(0);
        this.text.setText("");
        this.clickLock = false;
        let order: number[] = [];
        order = this.create3SolvableIndexArray();
        this.createBlocks(order, "key3");
    }

    create3SolvableIndexArray(): number[] {
        let indexArray = [];
        for (let i = 0; i < this.BOARD_DIM * this.BOARD_DIM; i++) {
            indexArray.push(i);
        }
        let scrambleIndex: number = 0;
        while (scrambleIndex < 6) {
            for (let j = 0; j < 100; j++) {
                let blackIndex = indexArray.indexOf(8);
                let rand = Math.random() * 4;
                if (rand < 1) {
                    if (blackIndex !== 0 && blackIndex !== 3 && blackIndex !== 6) {
                        this.swap(indexArray, blackIndex, blackIndex - 1);
                    }
                }
                else if (rand < 2) {
                    if (blackIndex !== 0 && blackIndex !== 1 && blackIndex !== 2) {
                        this.swap(indexArray, blackIndex, blackIndex - 3);
                    }
                }
                else if (rand < 3) {
                    if (blackIndex !== 2 && blackIndex !== 5 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 1);
                    }
                }
                else if (rand < 4) {
                    if (blackIndex !== 6 && blackIndex !== 7 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 3);
                    }
                }
            }
            for (let i = 0; i < indexArray.length; i++) {
                if (indexArray[i] !== i) {
                    scrambleIndex++;
                }
            }
        }
        return indexArray;
    }

    update() {
        this.setTime();
    }
}



// WEBPACK FOOTER //
// ./src/games/PuzzleSlider/scenes/MainScene.ts